export const SET_INPUTS = 'SET_INPUTS';
export const SET_INPUT = 'SET_INPUT';
export const ADD_INPUT = 'ADD_INPUT';
export const ADD_INPUTS = 'ADD_INPUTS';
export const UPDATE_INPUT = 'UPDATE_INPUT';
export const REMOVE_INPUT = 'REMOVE_INPUT';
export const CLEAR_INPUT = 'CLEAR_INPUT';
export const CLEAR_INPUTS = 'CLEAR_INPUTS';
